export default __webpack_public_path__ + "static/media/0x82b6205002ecd05e97642d38d61e2cfeac0e18ce.42a2e00b.webp";